import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faTrash } from "@fortawesome/free-solid-svg-icons";
import { useDropzone } from "react-dropzone";
import Header from "../repeat/Header";
import Footer from "../repeat/Footer";
import Leftnavigation from "./Leftnavigation";
import "./style/generaldeptevents.css";
import { Navigate } from "react-router-dom";

const Cmedeptevents = () => {
  const [images, setImages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [uploadError, setUploadError] = useState("");
  const [title, setTitle] = useState("");
  const [date, setDate] = useState("");
  const [description, setDescription] = useState("");
  const [imageFile, setImageFile] = useState(null);
  const [username, setUsername] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [showUploadForm, setShowUploadForm] = useState(false);

  // Fetch images and session data
  useEffect(() => {
    const storedUsername = sessionStorage.getItem("username");

    if (storedUsername) {
      setUsername(storedUsername);
    } else {
      setUsername(null);
    }
    setIsLoading(false);

    const fetchImages = async () => {
      try {
        const response = await fetch(
          "https://gptkpm.in/backend/admin/eeedeptevents.php"
        );
        if (!response.ok) {
          throw new Error("Failed to fetch images from the server.");
        }
        const data = await response.json();

        if (Array.isArray(data)) {
          setImages(data);
        } else {
          console.error("Unexpected response format:", data);
        }
      } catch (error) {
        console.error("Error fetching images:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchImages();
  }, []);

  // Handle file drop
  const onDrop = (acceptedFiles) => {
    if (acceptedFiles.length === 0) {
      setUploadError("No file selected. Please upload an image.");
      return;
    }

    const file = acceptedFiles[0];
    const fileType = file.type.split("/")[0];
    if (fileType !== "image") {
      setUploadError("Invalid file type. Please upload an image.");
      return;
    }

    setImageFile(file);
    setTitle("");
    setDescription("");
    setShowUploadForm(true);
  };

  // Handle form submission
  const handleUpload = async () => {
    if (!title || !description || !imageFile || !date) {
      setUploadError("Please provide a title, description, date, and image.");
      return;
    }

    const formData = new FormData();
    formData.append("image", imageFile);
    formData.append("title", title);
    formData.append("date", date);
    formData.append("description", description);
    formData.append("department", "General Department");

    try {
      const response = await fetch(
        "https://gptkpm.in/backend/admin/eeedeptevents.php",
        {
          method: "POST",
          body: formData,
        }
      );

      const data = await response.json();

      if (data.success) {
        setImages((prev) => [
          ...prev,
          {
            image: URL.createObjectURL(imageFile),
            title,
            description,
            date,
          },
        ]);
        alert("Image uploaded successfully!");
        setTitle("");
        setDescription("");
        setImageFile(null);
        setUploadError("");
        setShowUploadForm(false);
      } else {
        setUploadError(data.error || "Failed to upload image.");
      }
    } catch (error) {
      console.error("Error during upload:", error);
      setUploadError("An error occurred during image upload.");
    }
  };

  // Handle image deletion
  const handleDelete = async (title) => {
    try {
      const response = await fetch(
        "https://gptkpm.in/backend/admin/eeedeptevents.php",
        {
          method: "DELETE",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ title }),
        }
      );

      const data = await response.json();

      if (data.success) {
        setImages((prev) => prev.filter((item) => item.title !== title));
        alert("Image deleted successfully!");
      } else {
        console.error("Failed to delete image:", data.error);
      }
    } catch (error) {
      console.error("Error deleting image:", error);
    }
  };

  // Dropzone configuration
  const { getRootProps, getInputProps } = useDropzone({
    onDrop,
    accept: "image/*",
    multiple: false,
  });

  if (isLoading) {
    return <div>Loading...</div>;
  }

  if (!username) {
    return <Navigate to="/Admin" />;
  }

  return (
    <div id="top">
      <Header />
      <Leftnavigation />

      <div className="main-section">
        <div className="image-container">
        <div className="image-right">
            {!showUploadForm && (
              <div className="add-image" {...getRootProps()}>
                <input {...getInputProps()} />
                <FontAwesomeIcon icon={faPlus} className="add-icon" />
                <p>Drag & drop or click to upload</p>
              </div>
            )}

            {uploadError && <p className="error">{uploadError}</p>}

            {showUploadForm && (
              <div className="inner-text">
                <input
                  type="text"
                  placeholder="Enter image title"
                  value={title}
                  onChange={(e) => setTitle(e.target.value)}
                />
                <input
                  type="date"
                  value={date}
                  onChange={(e) => setDate(e.target.value)}
                />
                <textarea
                  placeholder="Enter image description"
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                />
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                  }}
                >
                  <button onClick={handleUpload}>Upload Image</button>
                  <button
                    onClick={() => setShowUploadForm(false)}
                    style={{ background: "red" }}
                  >
                    Close
                  </button>
                </div>
              </div>
            )}
          </div>
          <div className="images-left">
            {loading ? (
              <p>Loading images...</p>
            ) : (
              <div style={{ display: "flex", flexDirection: "column" }}>
                <h3 style={{ margin: "0 0 0 20px", textTransform: "capitalize" }}>
                  Electrical department images
                </h3>
                <div className="imagess">
                  {images.length > 0 ? (
                    images.map((item, index) => (
                      <div
                        key={index}
                        className="image-group"
                        style={{ backgroundImage: `url(${item.image})` }}
                      >
                        <div className="overlay">
                          <p className="image-title">{item.title}</p>
                          <p className="image-description">{item.description}</p>
                          <p className="image-description">{item.date}</p>
                          <button
                            className="delete-button"
                            onClick={() => handleDelete(item.title)}
                          >
                            <FontAwesomeIcon icon={faTrash} />
                          </button>
                        </div>
                      </div>
                    ))
                  ) : (
                    <p>No images available. Upload one to get started!</p>
                  )}
                </div>
              </div>
            )}
          </div>

          
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default Cmedeptevents;
